import axios from "axios";
import React, { useState, useEffect } from "react";
import { Button, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { useSelector } from "react-redux";
import useGetAllCategories from "../ReuseApi/useGetAllCategories";
import { useNavigate } from "react-router-dom";
import { taskPriorityOptions } from "../../utils/constant";
import useGetSubDepartments from "../ReuseApi/useGetSubDepartments";
import { useProjectList } from "../ReuseApi/useProjectList ";

export const CreateSelfTaskModel = ({ show, close }) => {
  const loginUserData = useSelector((state) => state.loginData.userData);

  // for redirect
  const navigate = useNavigate();

  // for map department
  const userDepartment = (loginUserData?.department || []).map((item) => ({
    value: item.value,
    label: item.label,
  }));


  // data for assign by leadname
  const resultData = Array.isArray(loginUserData.lead_name)
    ? loginUserData.lead_name.map((itm) => ({ value: itm, label: itm }))
    : { value: loginUserData.lead_id, label: loginUserData.lead_name };

  const optionsArray = resultData;

  // for indivisual state
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [initialHr, setInitialHr] = useState("");
  const [initialMin, setInitialMin] = useState("");
  const [taskpriority, setTaskpriority] = useState("");
  const [projectname, setProjectname] = useState("");
  const [categoryname, setCategoryname] = useState("");
  const [assignbyname, setAssignByName] = useState([]);
  const [departmentName, setDepartmentName] = useState(null);
  const [subDepartment, setSubDepartment] = useState(null);
  const [proposedStartDate, setProposedStartDate] = useState("")
  const [proposedEndDate, setProposedEndDate] = useState("")
  const [loader, setLoader] = useState(false);

  // state for error
  const [errors, setErrors] = useState({});

  // default department select
  useEffect(() => {
    if (userDepartment.length > 0 && !departmentName) {
      setDepartmentName(userDepartment[0]);
    }
  }, [userDepartment]);

  // use custome hook
  const departmentId = departmentName?.value;
  const { allCategoriesOptions } = useGetAllCategories(departmentName, subDepartment);
  const { projectOptions } = useProjectList(projectname?.value);
  const { subDeptOptions } = useGetSubDepartments(departmentId);


  // toast message
  const AddTaskSuccess = () => {
    toast.success("Add Self-Task Successfully", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
      toastId: "add-task-success"
    });
  };

  const InitialHrMinute = () => {
    toast.error(
      "00 hours and 00 minutes at the same time are not permitted, please choose an acceptable time.",
      {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        toastId: "initial-hr-min-error"
      }
    );
  };

  // function for error handling
  const handlerValidate = () => {
    let newErrors = {};

    if (!projectname) newErrors.projectname = "Required Field";
    // if (!categoryname) newErrors.categoryname = "Required Field";
    if (!assignbyname) newErrors.assignbyname = "Required Field";
    if (!taskpriority) newErrors.taskpriority = "Required Field";
    // if (!subDepartment) newErrors.subDepartment = "Required Field";
    if (!taskName.trim()) newErrors.taskName = "Required Field";
    if (!taskDescription.trim()) newErrors.taskDescription = "Required Field";
    if (!initialHr) newErrors.initialHr = "Required Field";
    if (assignbyname.length === 0) newErrors.assignbyname = "Required Field";
    if (!initialMin) newErrors.initialMin = "Required Field";
    if (!proposedStartDate) newErrors.proposedStartDate = "Required Field";
    if (!proposedEndDate) newErrors.proposedEndDate = "Required Field";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // reset data
  const resetForm = () => {
    setTaskName("");
    setTaskDescription("");
    setTaskpriority("");
    setDepartmentName(null);
    setProjectname(null);
    setCategoryname(null);
    setSubDepartment(null);
    setProposedStartDate("");
    setProposedEndDate("");
    setInitialHr("");
    setInitialMin("");
    setErrors({});
  };
  // function for submit data
  const handleSubmit = (e) => {
    if (handlerValidate()) {
      if (parseFloat(initialHr) === 0 && parseFloat(initialMin) === 0) {
        InitialHrMinute();
      } else {
        setLoader(true);
        const payload = {
          empId: loginUserData?.empId,
          taskName: taskName,
          taskDescription: taskDescription,
          taskPriority: taskpriority?.value,
          department_id: departmentName.value,
          departmentName: departmentName.label,
          taskDepartmentId: departmentName.value,
          taskDepartmentName: departmentName.label,
          projectId: projectname.value,
          projectName: projectname.label,
          AssignTask: "",
          assignBy_id: assignbyname.value,
          assignBy_Name: assignbyname.label,
          resource_id: loginUserData?.empId,
          resourceName: `${loginUserData.firstName} ${loginUserData.lastName}`,
          categoryOfName: categoryname?.label || "",
          category_id: categoryname?.value || "",
          proposedStartDate: proposedStartDate
            ? new Date(proposedStartDate).toISOString().split("T")[0]
            : "",
          proposedEndDate: proposedEndDate
            ? new Date(proposedEndDate).toISOString().split("T")[0]
            : "",
          initialEstimateHr: initialHr,
          initialEstimateMinutes: initialMin,
          estimateHr: "",
          subDepartmentId: subDepartment?.value,
          subDepartmentName: subDepartment?.label,
          status: "pending",
          logStatus: {
            status: "pending",
            resource_id: loginUserData?.empId,
            resourceName: `${loginUserData.firstName} ${loginUserData.lastName}`,
          },
        };

        axios
          .post(process.env.REACT_APP_BASE_URL + "/task/addTask", payload)
          .then((res) => {
            // { res.data.msg !== "Add Task Successfully" ? AlreadyTaskAdd() : AddTaskSuccess();
            AddTaskSuccess();
            setLoader(false);
            resetForm();
            navigate(`/${loginUserData?.resourceType}/self-task`);
            close();
            // }
          })
          .catch((err) => {
            setLoader(false);
            console.log("Error", err);
          });
      }
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={close}
        size="lg"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="mngmodelheader">
          <Modal.Title>
            <h5>Create Self Task</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body size="lg">
          <Row className="mb-3">
            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">Assign To</Form.Label>
                <Form.Control
                  value={`${loginUserData.firstName} ${loginUserData.lastName}`}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    color: "#6c757d",
                    cursor: "not-allowed",
                    opacity: 0.8
                  }}
                />
              </Form.Group>

            </Col>

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="">Department Name</Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  placeholder="Select..."
                  name="departmentName"
                  value={departmentName}
                  options={userDepartment}
                  onChange={(option) => {
                    setDepartmentName(option);
                  }}
                />
              </Form.Group>
            </Col>

            <Col sm={12} md={4}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  SubDepartment Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={subDepartment}
                  options={subDeptOptions}
                  isDisabled={!departmentName}
                  onChange={(option) => {
                    setSubDepartment(option);
                    setCategoryname(null);
                  }}
                />
                {/* {errors.subDepartment && (
                  <p className="errMsg">
                    <Icon.ExclamationTriangle className="me-2" />
                    {errors.subDepartment}
                  </p>
                )} */}
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={12} md={4}>
              <Form.Group controlId="formBasicId">
                <Form.Label>
                  Task Title
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Task Name"
                  name="taskName"
                  value={taskName}
                  onChange={(e) => {
                    if (
                      !e.target.value.match(
                        // /[+@#$&%!~=^_:{}\[\]*|//\-/?<>,;`'""/\\]/
                        /[#$&%!~=^_{}\[\]*|//\/?<>;`/\\]/
                      ) &&
                      e.target.value.trim()
                    ) {
                      setTaskName(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setTaskName(e.target.value);
                    }
                  }}
                />
              </Form.Group>
              {errors.taskName && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.taskName}
                </p>
              )}
            </Col>
            <Col sm={12} md={4}>
              <Form.Label className="emp-form-label mt-3 fw-bold">
                Task Priority
                <span className="requiredfield">*</span>
              </Form.Label>
              <Select
                isMulti={false}
                isSearchable={true}
                value={taskpriority}
                options={taskPriorityOptions}
                onChange={(option) => {
                  setTaskpriority(option);
                }}
              />
              {errors.taskpriority && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.taskpriority}
                </p>
              )}
            </Col>
            <Col sm={12} md={4}>
              <Form.Group controlId="formBasicId">
                <Form.Label className="">
                  Assign By
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={assignbyname}
                  options={optionsArray}
                  onChange={(option) => {
                    setAssignByName(option);
                  }}
                />
              </Form.Group>
              {errors.assignbyname && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.assignbyname}
                </p>
              )}
            </Col>

          </Row>

          <Row className="mb-3">
            <Col sm={12} md={12}>
              <Form.Group className="">
                <Form.Label className="mt-3 fw-bold">
                  Task Description <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Task Description"
                  name="taskdescription"
                  value={taskDescription}
                  onChange={(e) => {
                    if (e.target.value.trim()) {
                      setTaskDescription(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setTaskDescription(e.target.value);
                    }
                  }}
                />
              </Form.Group>
              {errors.taskDescription && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.taskDescription}
                </p>
              )}
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label>
                  Project Name
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={projectname}
                  options={projectOptions}
                  onChange={(option) => {
                    setProjectname(option);
                    if (option?.departmentId) {
                      setDepartmentName({
                        value: option.departmentId,
                        label: option.departmentName,
                      });
                    }
                  }}
                />
              </Form.Group>
              {errors.projectname && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.projectname}
                </p>
              )}
            </Col>
            <Col sm={12} md={6}>
              <Form.Group className="">
                <Form.Label>
                  Category Name
                  {/* <span className="requiredfield">*</span> */}
                </Form.Label>
                <Select
                  isMulti={false}
                  isSearchable={true}
                  value={categoryname}
                  options={allCategoriesOptions}
                  isDisabled={!departmentName || !subDepartment}
                  onChange={(option) => {
                    setCategoryname(option);
                  }}
                />
              </Form.Group>
              {/* {errors.categoryname && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.categoryname}
                </p>
              )} */}
            </Col>
          </Row>

          <Row className="mb-4">
            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" className="w-100">
                <Form.Label>
                  Proposed Start date <span className="requiredfield">*</span>
                </Form.Label>
                <InputGroup className="mb-2">
                  <Form.Control
                    className=""
                    type="date"
                    name="proposedstartdate"
                    value={
                      proposedStartDate
                        ? new Date(proposedStartDate)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    //  min={new Date().toISOString().split("T")[0]}
                    onKeyDown={(event) => event.preventDefault()}
                    onChange={(e) => {
                      setProposedStartDate(e.target.value);
                    }}
                  />
                </InputGroup>
              </Form.Group>
              {errors.proposedStartDate && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.proposedStartDate}
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label>
                  Proposed End date <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  className=""
                  type="date"
                  name="proposedenddate"
                  value={proposedEndDate
                    ? new Date(proposedEndDate)
                      .toISOString()
                      .split("T")[0]
                    : ""
                  }
                  min={proposedStartDate}
                  disabled={proposedStartDate?.length === 0}
                  onChange={(e) => {
                    setProposedEndDate(e.target.value);
                  }}
                />
              </Form.Group>
              {errors.proposedEndDate && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.proposedEndDate}
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label>
                  Initial Estimate(Hours){" "}
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Estimate Hr"
                  name="initialEstimateHr"
                  value={initialHr}
                  onChange={(e) => {
                    if (
                      /^[0-9]*(\.[0-9]*)?$/.test(e.target.value) &&
                      e.target.value.length <= 4
                    ) {
                      setInitialHr(e.target.value);
                    } else if (e.target.value.length === 0) {
                      setInitialHr(e.target.value);
                    }
                  }}
                />
              </Form.Group>
              {errors.initialHr && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.initialHr}
                </p>
              )}
            </Col>

            <Col sm={12} md={3}>
              <Form.Group controlId="formBasiContact" style={{ width: "100%" }}>
                <Form.Label>
                  Initial Minutes
                  <span className="requiredfield">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Initial Minutes"
                  name="initialEstimateMinutes"
                  value={initialMin}
                  onChange={(e) => {
                    if (
                      /^[0-9]{0,2}$/.test(e.target.value) &&
                      e.target.value >= 0 &&
                      e.target.value <= 59
                    ) {
                      setInitialMin(e.target.value);
                    } else if (e.target.value > 59) {
                      toast.error("Please enter a value between 0 and 59.");
                    } else if (e.target.value.length === 0) {
                      setInitialMin(e.target.value);
                    }
                  }}
                />
              </Form.Group>
              {errors.initialMin && (
                <p className="errMsg">
                  <Icon.ExclamationTriangle className="me-2" />
                  {errors.initialMin}
                </p>
              )}
            </Col>
          </Row>
        </Modal.Body >

        <Modal.Footer className="text-center mt-4">
          <Button
            className="primaryBtn"
            onClick={() => {
              handleSubmit();
            }}
            disabled={loader}
          >
            <Icon.PersonAdd className="me-2" /> Create Task
          </Button>
        </Modal.Footer>
      </Modal >
    </>
  );
};
